const listSubgroup = (query) => {
	return `query listSubgroup {
		listSubgroup {
			${query}
		}
	}`;
}

export default listSubgroup;
